import classes from "./Portfolio.module.css";
import videoGamesCenterIMG from "../img/Captura de pantalla_20230207_044102.png";
import barbaerSHOPIMG from "../img/barbersho_img.png";
import reviewanythingIMG from "../img/reviewanything_img.png";
import PortfolioElement from "./PortfolioElement";
import { FaHtml5, FaCss3Alt, FaReact } from "react-icons/fa";
import { SiJavascript, SiTailwindcss, SiFirebase } from "react-icons/si";
import { SiDotnet, SiCsharp, SiDocker, SiPostgresql, SiNextdotjs } from "react-icons/si";
const Portfolio2 = () => {
  const icons = [
    <FaHtml5 style={{ color: "#ff781f" }} />,
    <FaCss3Alt style={{ color: "#3388ff" }} />,
    <SiJavascript style={{ color: "#f7cd1d" }} />,
    <FaReact style={{ color: "#3388ff" }} />,
    <SiTailwindcss style={{ color: "#3388ff" }} />,
    <SiNextdotjs style={{ color: "#000000" }} />,
    <SiFirebase style={{ color: "#f7cd1d" }} />,
    <SiDotnet style={{ color: "#512bd4" }} />,
    <SiCsharp style={{ color: "#239120" }} />,      
    <SiDocker style={{ color: "#0db7ed" }} />,      
    <SiPostgresql style={{ color: "#336791" }} />,  
  ];
  const sliderContent = [
    {
      img: reviewanythingIMG,
      title: "ReviewAnythingAPP", 
      description:
        "-Desarrollé una plataforma de reseñas full-stack con API en .NET 9 y frontend en Blazor Server, utilizando componentes modernos de C# y Razor.\n-Implementé autenticación segura con JWT y control de acceso basado en roles, incluyendo integración con Google OAuth y restablecimiento de contraseña por correo electrónico.\n-Diseñé y optimicé el esquema de base de datos en PostgreSQL usando Entity Framework Core con Identity para la gestión de usuarios y permisos.\n-Construí y contenedoricé tanto el frontend como el backend con Docker para facilitar el despliegue escalable y mantener entornos consistentes.\n-Implementé operaciones CRUD para reseñas con una interfaz responsiva y retroalimentación en tiempo real, asegurando una experiencia fluida en distintos dispositivos.",
      sitelink: "https://reviewanything.site/",
      icons: icons.slice(7, 11),
      gitHub: "https://github.com/alejandro-saav/ReviewAnythingApp",
      apis: ["Restful .NET9 API, Google API, Resend API, Cloudinary API"],
    },
    {
      img: videoGamesCenterIMG,
      title: "Videogames Center",
      description:
        "- Desarrollé una aplicación web interactiva con React que permite explorar videojuegos utilizando datos reales desde una API externa.\n- Implementé funcionalidades como búsqueda, filtrado por género, ordenamiento y paginación para mejorar la experiencia del usuario.\n- Utilicé React Router para navegación dinámica y una arquitectura basada en componentes reutilizables.\n- Apliqué estilos personalizados con CSS modular y diseño responsive para compatibilidad en dispositivos móviles y escritorio.\n- Gestioné el estado global de la app con React Context y optimicé el rendimiento mediante carga perezosa y memoización.",
      icons: icons.slice(0, 4),
      gitHub: "https://github.com/NexxRoxx/Videogames-project",
      sitelink: "https://videogamescenter.netlify.app/homepage",
      apis: ["IGDB API"],
    },
    {
      img: barbaerSHOPIMG,
      title: "Barbershop",
      description:
        "- Desarrollé una plataforma web para barberías que permite a los clientes agendar citas en línea con interfaz sencilla e intuitiva.\n- Implementé autenticación de usuarios y gestión de citas usando tecnologías modernas como Next.js y bases de datos PostgreSQL.\n- Incluí un panel administrativo donde los barberos pueden ver y gestionar sus horarios, servicios y disponibilidad.\n- Usé correo electrónico para notificaciones y confirmaciones de cita automáticas, mejorando la comunicación con los clientes.\n- Aseguré un diseño moderno y adaptativo con Tailwind CSS, ofreciendo una experiencia fluida desde móviles hasta escritorio.",
      gitHub: "https://github.com/alejandro-saav/barbershop",
      sitelink: "https://hardwarepccomponents.netlify.app/",
      icons: [icons.slice(0,6).reverse()],
      apis: ["Cloudinary"],
    },
  ];
  return (
    <div className={classes.slider}>
      <div className={classes.wraper}>
        {sliderContent.map((item, index) => {
          return (
            <PortfolioElement
              img={item.img}
              title={item.title}
              description={item.description}
              icons={item.icons}
              apis={item.apis}
              prueba={item.icons}
              github={item.gitHub}
              sitelink={item.sitelink}
              key={index}
            />
          );
        })}
      </div>
    </div>
  );
};

export default Portfolio2;
